import React, { useState, useEffect } from "react";
import { Container, Card } from "react-bootstrap";
import DashboardNavbar from "./DashboardNavbar";
import "bootstrap/dist/css/bootstrap.min.css";
import { getData } from "../api/protectedApi";
import Home from "./Home";
import UpgradeButton from "./upgradeButton";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FaUsers,
  FaUserFriends,
  FaWallet
} from "react-icons/fa";


const DashboardHome = () => {
  const [dashboard, setDashboard] = useState({});
  const [referralLink, setReferralLink] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await getData("/dashboard");
      if (res?.data?.data) {
        setDashboard(res.data.data);
        setReferralLink(
          `https://hifiinternationals.com/register?sponser_id=${res.data.data.walletAddress}`
        );
      }
    } catch (error) {
      toast.error("Failed to load dashboard");
    }
  };

  const copyReferral = async () => {
    await navigator.clipboard.writeText(referralLink);
    setCopied(true);

    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{ backgroundColor: "#0d0e13", minHeight: "100vh" }}>
      <DashboardNavbar />
      <Home />

      {/* HEADER */}
      <section>
        <div className="container py-5">
          <div className="mb-4">
            <div className="welcome">Welcome to Hifi Internationals</div>
            <div className="hello">
              Hello, {dashboard?.name || "User"}
            </div>
          </div>

          {/* POOLS */}
          <div className="row g-4">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="race-card">
                <div className="race-badge">Active: $30</div>
                <div className="race-title">Activation Pool</div>
                <div className="race-desc">
                  A fast-paced dash for beginners and speed lovers.
                </div>
                <Link to="/activationpool">
                  <button className="view-btn">View</button>
                </Link>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <UpgradeButton />
            </div>
          </div>
        </div>
      </section>

      {/* NETWORK STATUS */}
      <section>
        <div className="container py-5">
          <h2 className="stats-title">My Network Status</h2>

          <div className="network-row">

            {/* Total Members */}
            <div className="network-col">
              <div className="network-card">
                <div className="network-icon">
                  <FaUsers size={22} />
                </div>
                <div className="network-label">My Total Members</div>
                <div className="network-value">
                  {dashboard?.total_team || 0}
                </div>
              </div>
            </div>

            {/* Direct Members */}
            <div className="network-col">
              <div className="network-card">
                <div className="network-icon">
                  <FaUserFriends size={22} />
                </div>
                <div className="network-label">My Directs</div>
                <div className="network-value">
                  {dashboard?.directs || 0}
                </div>
              </div>
            </div>

            {/* Withdrawals */}
            <div className="network-col">
              <div className="network-card">
                <div className="network-icon withdraw">
                  <FaWallet size={22} />
                </div>
                <div className="network-label">Income Withdrawals</div>
                <div className="network-value">
                  {dashboard?.directIncome || "0.00"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* REFERRAL */}
      <section>
        <div className="container py-5">
          <h2 className="ref-title">Your Referral Link</h2>

          <div className="ref-box">
            <div className="ref-info">
              Join first, then you can get your referral id.
            </div>

            <div className="row g-3 align-items-center">
              <div className="col-lg-9 col-md-8 col-12">
                <input
                  type="text"
                  className="form-control ref-input"
                  value={referralLink}
                  readOnly
                />
              </div>

              <div className="col-lg-3 col-md-4 col-12 text-end">
                <button
                  className="copy-btn w-100"
                  onClick={copyReferral}
                >
                  {copied ? "Copied " : "Copy Link"}
                </button>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

  );
};

export default DashboardHome;
